import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  id: "bot-container"
};
const _hoisted_2 = {
  id: "Aurora-Dia",
  class: "Aurora-Dia"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock(_Transition, {
    name: "fade-bounce-y",
    mode: "out-in",
    persisted: ""
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
      id: "Aurora-Dia--body",
      style: _normalizeStyle(_ctx.cssVariables)
    }, [_cache[1] || (_cache[1] = _createElementVNode("div", {
      id: "Aurora-Dia--tips-wrapper"
    }, [_createElementVNode("div", {
      id: "Aurora-Dia--tips",
      class: "Aurora-Dia--tips"
    }, "早上好呀～")], -1 /* HOISTED */)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
      id: "Aurora-Dia--eyes",
      class: _normalizeClass(["Aurora-Dia--eyes", {
        'Aurora-Dia--eyes-dark': _ctx.isDark
      }])
    }, _cache[0] || (_cache[0] = [_createElementVNode("div", {
      id: "Aurora-Dia--left-eye",
      class: "Aurora-Dia--eye left"
    }, null, -1 /* HOISTED */), _createElementVNode("div", {
      id: "Aurora-Dia--right-eye",
      class: "Aurora-Dia--eye right"
    }, null, -1 /* HOISTED */)]), 2 /* CLASS */)]), _cache[2] || (_cache[2] = _createElementVNode("div", {
      class: "Aurora-Dia--platform"
    }, null, -1 /* HOISTED */))], 4 /* STYLE */)], 512 /* NEED_PATCH */), [[_vShow, _ctx.showDia]])]),
    _: 1 /* STABLE */
  });
}